export const SliderData = [
  {
    bg: "f5fafd",
    image: "https://i.postimg.cc/02QVn21W/pngaaa-com-3824066.png",
    title: "Summer Sale",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry and it is majorly used in the computer insdustry to use it as a tempalte to type the words",
  },
  {
    bg: "fbf0f4",
    image: "https://i.postimg.cc/02QVn21W/pngaaa-com-3824066.png",
    title: "Winter Sale",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry and it is majorly used in the computer insdustry to use it as a tempalte to type the words",
  },
  {
    bg: "fcf1ed",
    image: "https://i.postimg.cc/02QVn21W/pngaaa-com-3824066.png",
    title: "Diwali Sale",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry and it is majorly used in the computer insdustry to use it as a tempalte to type the words",
  },
];

export const Category = [
  {
    id: 1,
    img: "https://images.unsplash.com/photo-1621072156002-e2fccdc0b176?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    title: "shirts",
    category: "shirt",
  },
  {
    id: 2,
    img: "https://images.unsplash.com/photo-1473966968600-fa801b869a1a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    title: "pants",
    category: "pant",
  },
  {
    id: 1,
    img: "https://images.unsplash.com/photo-1519804270019-39e929a7afb5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    title: "sweaters",
    category: "sweater",
  },
];

export const popularProducts = [
  {
    id: 1,
    img: "https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
  },
  {
    id: 2,
    img: "https://assets.stickpng.com/images/58454896a6515b1e0ad75b82.png",
  },
  {
    id: 3,
    img: "https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
  },
  {
    id: 4,
    img: "https://assets.stickpng.com/images/5bb36103554c7f08176ec0e7.png",
  },
  {
    id: 5,
    img: "https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
  },
  {
    id: 6,
    img: "https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
  },
  {
    id: 7,
    img: "https://assets.stickpng.com/images/5bb36142554c7f08176ec0ef.png",
  },
  {
    id: 8,
    img: "https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
  },
];
